import React, { useState } from "react";
import "./Step6.css";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const Step6 = () => {
  const [premisesCount, setPremisesCount] = useState(1);
  const [mainLocation, setMainLocation] = useState("");
  const [premisesType, setPremisesType] = useState("");
  const [rentMarketRate, setRentMarketRate] = useState("");
  const [standardMarketRent, setStandardMarketRent] = useState("");
  const [performanceReview, setPerformanceReview] = useState("");
  const [locationImportance, setLocationImportance] = useState("");

  // Address Form States
  const [addresses, setAddresses] = useState([
    { address: "", city: "", postCode: "", country: "" },
  ]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      premisesCount,
      mainLocation,
      premisesType,
      rentMarketRate,
      standardMarketRent,
      performanceReview,
      locationImportance,
      addresses,
    });
  };

  const handleAddressChange = (index, field, value) => {
    const newAddresses = [...addresses];
    newAddresses[index][field] = value;
    setAddresses(newAddresses);
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={8} xl={6}>
          <Card className="overflow-hidden">
            <div className="bg-primary text-center p-4">
              <h5 className="text-white font-size-20">Business Premises</h5>
              <p className="text-white-50">
                Now we’re getting into the nitty-gritty of your business finances. We recommend having all your financial records handy, especially your profit and loss statement and balance sheet.
              </p>
            </div>
            <CardBody className="p-4">
              <Form onSubmit={handleSubmit}>
                {/* Premises Count Tiles */}
                <FormGroup>
                  <Label>How many premises do you operate out of?</Label>
                  <div className="d-flex justify-content-between">
                    {[1, 2, 3, 4, "5+"].map((number, index) => (
                      <div
                        key={index}
                        className={`box ${premisesCount === number ? "selected" : ""}`}
                        onClick={() => {
                          setPremisesCount(number);
                          if (number === 1) {
                            setAddresses([{ address: "", city: "", postCode: "", country: "" }]);
                          } else if (number === 2) {
                            setAddresses([
                              { address: "", city: "", postCode: "", country: "" },
                              { address: "", city: "", postCode: "", country: "" },
                            ]);
                          } else {
                            setAddresses([]); // No address forms for 3, 4, or 5+
                          }
                        }}
                      >
                        {number}
                      </div>
                    ))}
                  </div>
                </FormGroup>

                {/* Main Location Radio Buttons */}
                {premisesCount && (
                  <FormGroup>
                    <Label>Is this the main business location?</Label>
                    <div>
                      {["Yes", "No"].map((option) => (
                        <FormGroup check key={option}>
                          <Input
                            type="radio"
                            name="mainLocation"
                            value={option}
                            checked={mainLocation === option}
                            onChange={(e) => setMainLocation(e.target.value)}
                          />{" "}
                          <Label check>{option}</Label>
                        </FormGroup>
                      ))}
                    </div>
                  </FormGroup>
                )}

                {/* Premises Type Radio Buttons */}
                {mainLocation && (
                  <>
                    <FormGroup>
                      <Label>Is this premises leased or owned?</Label>
                      <div>
                        {["Leased", "Owned"].map((option) => (
                          <FormGroup check key={option}>
                            <Input
                              type="radio"
                              name="premisesType"
                              value={option}
                              checked={premisesType === option}
                              onChange={(e) => setPremisesType(e.target.value)}
                            />{" "}
                            <Label check>{option}</Label>
                          </FormGroup>
                        ))}
                      </div>
                    </FormGroup>
                    <FormGroup>
                  <Label>How essential is your current location to the success of your business?</Label>
                  <div>
                    {[
                      "Not important. We could move anytime without affecting the business.",
                      "Somewhat critical. Moving would impact the business, but it would recover.",
                      "Fairly critical. Moving would significantly impact the business.",
                      "Critical. The business would not survive in a different location.",
                    ].map((option, index) => (
                      <FormGroup check key={index}>
                        <Input
                          type="radio"
                          name="locationImportance"
                          value={option}
                          onChange={(e) => setLocationImportance(e.target.value)}
                        />{" "}
                        <Label check>{option}</Label>
                      </FormGroup>
                    ))}
                  </div>
                </FormGroup>

                    {/* Address Form */}
                    <h5>Business Location Details</h5>
                    {addresses.map((address, index) => (
                      <div key={index}>
                        <h6>Address {index + 1}</h6> {/* Added title for each address */}
                        <FormGroup>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <div style={{ flex: 1 }}>
                              <Label>Address</Label>
                              <Input
                                type="text"
                                placeholder="Enter Address"
                                value={address.address}
                                onChange={(e) =>
                                  handleAddressChange(index, "address", e.target.value)
                                }
                              />
                            </div>
                            <div style={{ flex: 1 }}>
                              <Label>City</Label>
                              <Input
                                type="text"
                                placeholder="Enter City"
                                value={address.city}
                                onChange={(e) =>
                                  handleAddressChange(index, "city", e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </FormGroup>

                        <FormGroup>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <div style={{ flex: 1 }}>
                              <Label>Post Code</Label>
                              <Input
                                type="text"
                                placeholder="Enter Post Code"
                                value={address.postCode}
                                onChange={(e) =>
                                  handleAddressChange(index, "postCode", e.target.value)
                                }
                              />
                            </div>
                            <div style={{ flex: 1 }}>
                              <Label>Country</Label>
                              <Input
                                type="text"
                                placeholder="Enter Country"
                                value={address.country}
                                onChange={(e) =>
                                  handleAddressChange(index, "country", e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                    ))}
                  </>
                )}

                {/* Rent Market Rate Radio Buttons */}
                {premisesType === "Leased" && (
                  <FormGroup>
                    <Label>Is the rent paid at standard market rates (commercial terms)?</Label>
                    <div>
                      {["Yes", "No"].map((option) => (
                        <FormGroup check key={option}>
                          <Input
                            type="radio"
                            name="rentMarketRate"
                            value={option}
                            checked={rentMarketRate === option}
                            onChange={(e) => setRentMarketRate(e.target.value)}
                          />{" "}
                          <Label check>{option}</Label>
                        </FormGroup>
                      ))}
                    </div>
                  </FormGroup>
                )}

                {/* Standard Market Rent Input */}
                {rentMarketRate === "No" && (
                  <FormGroup>
                    <Label>What would the standard market rent be for this premises?</Label>
                    <Input
                      type="number"
                      placeholder="Enter amount"
                      value={standardMarketRent}
                      onChange={(e) => setStandardMarketRent(e.target.value)}
                    />
                  </FormGroup>
                )}

                {/* Performance Review Radio Buttons */}
                <FormGroup>
                  <Label>How often does the business conduct performance reviews for staff?</Label>
                  <div>
                    {["Quarterly", "Every 6 months", "Once a year", "We don't currently do this"].map((option) => (
                      <FormGroup check key={option}>
                        <Input
                          type="radio"
                          name="performanceReview"
                          value={option}
                          checked={performanceReview === option}
                          onChange={(e) => setPerformanceReview(e.target.value)}
                        />{" "}
                        <Label check>{option}</Label>
                      </FormGroup>
                    ))}
                  </div>
                </FormGroup>

                {/* Location Importance Radio Buttons */}
              

                {/* Submit Button */}
                {/* <div className="text-end">
                  <Button color="primary" type="submit">
                    Submit
                  </Button>
                </div> */}
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Step6;